import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';


const FORM_VALUES = {
  'colorCode': '',
  'type': '',
  'colorDescription': '',
  'specialDescription': '',
  'status': 'A',
  'udcJdeSy': '',
  'udcJdeRt': '',
};

const FORM_INITIAL_STATE = {
  'loading': false,
  'saving': false,
  'initialValues': FORM_VALUES,
  'values': {
    ...FORM_VALUES,
  },
};

export const manageColorsForm = (state, action) => {
  return createReducer(FORM_INITIAL_STATE, {
    [ActionTypes.CREATING_COLOR]: (state, action) => ({
      ...state,
      'saving': true,
    }),
    [ActionTypes.CREATED_COLOR]: (state, action) => ({
      ...state,
      'saving': false,
    }),
    [ActionTypes.CREATED_COLOR_FAILED]: (state, action) => ({
      ...state,
      'saving': false,
    }),
  })(state, action);
};
